import React, { useEffect, useState } from "react";
import { SAND_CAT } from "./config";

const OAuthCallback = () => {
  const [authResult, setAuthResult] = useState(null); // 'success', 'error', or null (processing)

  useEffect(() => {
    const handleOAuthResponse = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const paramsObject = {};
      for (const [key, value] of queryParams.entries()) {
        paramsObject[key] = value;
      }

      const relayId = paramsObject.state;

      if (!relayId) {
        console.error("No relayId (state) found in OAuth callback");
        setAuthResult("error");
        return;
      }

      const source = relayId.substring(0, 1);

      // Call backend API with relayId to retrieve session data and complete OAuth
      const req = {
        oauthCode: paramsObject.code,
        oauthScope: paramsObject.scope,
        oauthState: paramsObject.state,
        relayId: relayId,
      };

      try {
        const fetchResponse = await fetch(
          `${SAND_CAT}/integration/oauth/code/callback`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify(req),
          }
        );

        const response = await fetchResponse.json();

        // Unified logic: show result page after fetchResponse
        if (fetchResponse.ok && response && !response.error) {
          // For app source, redirect to app intent
          if (source === "a") {
            window.location.href = `mhomeai://auth/oauth-callback?success=true`;
            // Fallback to success page after short delay
            setTimeout(() => {
              setAuthResult("success");
            }, 1000);
          } else {
            setAuthResult("success");
          }
        } else {
          // For app source, redirect to app intent with error
          if (source === "a") {
            window.location.href = `mhomeai://auth/oauth-callback?success=false`;
            // Fallback to error page after short delay
            setTimeout(() => {
              setAuthResult("error");
            }, 1000);
          } else {
            setAuthResult("error");
          }
        }
      } catch (error) {
        console.error("Error during OAuth callback:", error);

        // For app source, redirect to app intent with error
        if (source === "a") {
          window.location.href = `mhomeai://auth/oauth-callback?success=false`;
          // Fallback to error page after short delay
          setTimeout(() => {
            setAuthResult("error");
          }, 1000);
        } else {
          setAuthResult("error");
        }
      }
    };

    handleOAuthResponse();
  }, []);

  // Show unified result page directly in this component
  if (authResult === null) {
    // Processing state
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          textAlign: "center",
          fontFamily: "sans-serif",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            color: "#6c757d",
            marginBottom: "20px",
          }}
        >
          Processing auth...
        </div>
        <div
          style={{
            width: "32px",
            height: "32px",
            border: "3px solid #e9ecef",
            borderTop: "3px solid #007bff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // Success or Error result page
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        fontFamily: "sans-serif",
        backgroundColor: "#f8f9fa",
      }}
    >
      <div
        style={{
          backgroundColor: authResult === "success" ? "#d4edda" : "#f8d7da",
          color: authResult === "success" ? "#155724" : "#721c24",
          border:
            authResult === "success"
              ? "1px solid #c3e6cb"
              : "1px solid #f5c6cb",
          borderRadius: "8px",
          padding: "24px 32px",
          marginBottom: "20px",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        {authResult === "success" ? "✅ Auth Success" : "❌ Auth Error"}
      </div>
      <p style={{ color: "#6c757d", fontSize: "16px", margin: 0 }}>
        You can close this page now.
      </p>
    </div>
  );
};

export default OAuthCallback;
